type ProfinderSiteEnvironment = {
  NEXT_PUBLIC_PROFINDER_URL?: string
  NEXT_PUBLIC_ENV?: string
  NODE_ENV?: string
}

/** Shared by Next configuration and browser route builders so links and redirects agree. */
export function getProfinderSiteUrl(source: ProfinderSiteEnvironment = {
  NEXT_PUBLIC_PROFINDER_URL: process.env.NEXT_PUBLIC_PROFINDER_URL,
  NEXT_PUBLIC_ENV: process.env.NEXT_PUBLIC_ENV,
  NODE_ENV: process.env.NODE_ENV,
}): string {
  const configured = source.NEXT_PUBLIC_PROFINDER_URL?.trim()
  const fallback = source.NEXT_PUBLIC_ENV === 'local' || source.NODE_ENV !== 'production'
    ? 'http://localhost:8081'
    : source.NEXT_PUBLIC_ENV === 'development'
      ? 'https://profinder-dev.hubhive.com'
      : 'https://profinder.hubhive.com'
  const url = new URL(configured || fallback)
  if (!['http:', 'https:'].includes(url.protocol) || url.username || url.password || url.search || url.hash) {
    throw new Error('NEXT_PUBLIC_PROFINDER_URL must be an HTTP(S) site URL without credentials, query, or fragment')
  }
  return url.toString().replace(/\/+$/, '')
}

export function profinderUrl(path = '/'): string {
  return `${getProfinderSiteUrl()}${path.startsWith('/') ? path : `/${path}`}`
}
